import ATLvsBTL from '../assets/images/mediaservices/ATLvsBTL.jpg';

import strategyicon from '../assets/images/mediaservices/strategy.jpg';
import marketingicon from '../assets/images/mediaservices/marketing.jpg';
import creativeandproductioniconicon from '../assets/images/mediaservices/creativeproduction.jpg';
import eventandexperneicesiconicon from '../assets/images/mediaservices/events.jpg';
import mediatechnologyicon from '../assets/images/mediaservices/mediatechnology.jpg';
import ormicon from '../assets/images/mediaservices/orn.jpg';

export const mediaServices = [
  {
    slug: "strategy",
    title: "Strategy",
    image: strategyicon,
    icon: strategyicon,
    hotspot: { top: "22%", left: "42%" },
    hero: "WE STALK YOUR AUDIENCE. LEGALLY, OF COURSE.",
    intro:
      "Before we spend your budget, roll the cameras, or jump on the latest trend, we figure out what actually matters to the people you're trying to reach.\n\nWe dig into your brand, your audience, your competition, and the culture around them. The goal isn't to follow what's already working it's to understand why it works and where your brand fits in.\n\nBecause strategy isn't guessing. It's knowing where to play before you make your move.",
    sections: [
      {
        title: "Our Approach",
        text: "Strategy is Where Every Great Story Begins.\n\nAt HKI Media, we don't jump into execution we uncover opportunities first. Every brand has a unique story, audience, and ambition. By combining market intelligence, consumer behavior, cultural trends, and business objectives, we build strategies that inspire creativity and drive measurable growth. Every idea has a purpose, every campaign has direction, and every execution is backed by insight.",
      },
      {
        title: "Why Strategy Matters",
        items: [
          [
            "01 | Insight-Driven Decisions",
            "Every recommendation is powered by research, market trends, competitor analysis, and consumer intelligence so your brand stays relevant, not reactive.",
          ],
          [
            "02 | Audience-First Thinking",
            "We go beyond demographics to understand motivations, behaviors, and cultural moments that influence buying decisions, helping your brand build genuine connections.",
          ],
          [
            "03 | Purpose-Led Growth",
            "Creative only works when it serves a business objective. Every strategy is aligned with your goals whether it's building awareness, driving sales, or strengthening brand equity.",
          ],
          [
            "04 | Consistency Across Every Touchpoint",
            "From branding and content to digital campaigns and customer experiences, strategy creates a unified brand presence that people recognize, trust, and remember.",
          ],
        ],
      },
    ],
    closing:
      "The strongest brands do not grow by chance. They grow with a clear strategy, the right direction, and consistent execution. Let's build a strategy that moves your brand forward.",
  },
  {
    slug: "marketing",
    title: "Marketing",
    image: marketingicon,
    icon: marketingicon,
    hotspot: { top: "45%", left: "38%" },
    hero: "YOUR AUDIENCE DOESN'T NEED MORE CONTENT. THEY NEED A BETTER REASON TO STOP SCROLLING.",
    intro:
      "Algorithms don't reward brands.\n\nPeople do.\n\nThat's why we don't start with formats, platforms or trends. We start with human behaviour. Then we build campaigns that naturally earn attention across social, digital, creators, paid media and experiences.\n\nEvery click has a purpose.\n\nEvery view has somewhere to go.\n\nEvery campaign has a job beyond looking good in a monthly report.",
    sections: [
      {
        title: "Our Marketing Services",
        text: "Marketing Built for Modern Brands\n\nWe combine strategy, creativity, technology, and performance to create marketing ecosystems that build awareness, drive engagement, and accelerate business growth.",
        items: [
          [
            "01 | Digital Marketing",
            "We build integrated digital ecosystems where content, media, technology, and analytics work together to create measurable growth across every customer touchpoint.",
          ],
          [
            "02 | Performance Marketing",
            "From paid social and search to programmatic advertising, we create data-driven campaigns that maximize reach, optimize conversions, and deliver measurable ROI.",
          ],
          [
            "03 | Influencer Marketing",
            "We connect your brand with creators who genuinely resonate with your audience, crafting authentic collaborations that build trust, engagement, and cultural relevance.",
          ],
          [
            "04 | Affiliate Marketing",
            "Expand your reach through strategic partnerships with publishers, creators, and affiliate networks, where every campaign is designed to drive performance and revenue.",
          ],
          [
            "05 | Meme & Culture Marketing",
            "We tap into internet culture, viral trends, and real-time conversations to create content that sparks engagement, encourages sharing, and keeps your brand part of the cultural dialogue.",
          ],
          [
            "06 | Social Media Management",
            "From strategy and content creation to community management and performance analysis, we build social media experiences that strengthen your brand and foster meaningful engagement.",
          ],
        ],
      },
    ],
    closing:
      "The best marketing does not interrupt people. It earns their attention. Let's build marketing that creates visibility, builds trust, and delivers measurable growth.",
  },
  {
    slug: "creative-and-production",
    title: "Creative & Production",
    image: creativeandproductioniconicon,
    icon: creativeandproductioniconicon,
    hotspot: { top: "55%", left: "52%" },
    hero: "WE DON'T PRESS RECORD UNTIL THE IDEA DESERVES IT.",
    intro:
      "Cameras don't create great content.\n\nIdeas do.\n\nWe write. Design. Direct. Shoot. Animate. Edit. Repeat. Whatever the format, every creative decision is made with one question in mind\n\n\"Would someone actually choose to watch this?\"\n\nBecause production quality gets compliments.\n\nCreative quality gets customers.",
    sections: [
      {
        title: "Creative & Production Services",
        text: "Ideas That Inspire. Content That Performs.\n\nWe blend creativity, storytelling, design, and production to craft compelling brand experiences that capture attention, build connections, and drive measurable results.",
        items: [
          [
            "01 | Content Strategy & Creation",
            "Purposeful content. Powerful storytelling.\n\nEvery piece of content is created with strategy at its core designed to educate, entertain, engage, and convert across every platform.\n\nOur Content Services: Content Strategy, Social Media Content, Copywriting, Blogs & Articles, Website Content, Email Marketing Content, Campaign Concepts, Content Calendars, Brand Storytelling, SEO Content.",
          ],
          [
            "02 | Video Production",
            "Stories brought to life through motion.\n\nFrom concept to final cut, we produce cinematic, high impact videos that communicate your brand's message with creativity and precision.\n\nOur Video Production Services: Brand Films, Commercial Advertisements, Corporate Videos, Product Videos, Social Media Reels & Shorts, Testimonial Videos, Event Coverage, Fashion & Lifestyle Shoots, Food & Hospitality Shoots, Drone Cinematography.",
          ],
          [
            "03 | Production Capabilities",
            "End-to-end production under one roof.\n\nWe manage every stage of production, ensuring every project is delivered with exceptional quality, consistency, and creative excellence.\n\nOur Production Expertise: Creative Concept Development, Scriptwriting, Storyboarding, Photography, Videography, Multi Camera Productions, Podcast Production, Interviews & Talk Shows, Motion Graphics, 2D & 3D Animation, Video Editing, Color Grading, Sound Design & Voiceovers.",
          ],
          [
            "04 | Branding & Design",
            "Design that shapes perception.\n\nWe build memorable visual identities and creative assets that communicate your brand consistently across every customer touchpoint.\n\nOur Design Services: Brand Identity Design, Logo Design, Brand Guidelines, Packaging Design, Marketing Collateral, Social Media Creatives, Print Design, Presentation Design, UI/UX Design, Website Design, Event Branding.",
          ],
          [
            "05 | Virtual Creation & Digital Experiences",
            "Creating immersive digital first experiences.\n\nWe leverage creativity and technology to design impactful digital assets that elevate communication, engagement, and brand presence across virtual platforms.\n\nOur Virtual Creation Services: Digital Brand Assets, 3D Visualisation, CGI Content, Motion Design, Interactive Presentations, AR & VR Experiences, Digital Event Assets, Virtual Product Launches, Digital Illustrations, AI-Generated Creative Assets.",
          ],
        ],
      },
    ],
  },
  {
    slug: "event",
    title: "Events & Experiences",
    image: eventandexperneicesiconicon,
    icon: eventandexperneicesiconicon,
    hotspot: { top: "35%", left: "60%" },
    hero: "WE CREATE FOMO. PROFESSIONALLY.",
    intro:
      "The best events don't end when the lights go out.\n\nThey live on in conversations, photos, recommendations and stories people can't stop telling.\n\nFrom product launches and brand activations to corporate events and immersive experiences, we choreograph every detail so your audience doesn't just attend they become part of the story.\n\nBecause attendance is a number.\n\nImpact is what people remember.",
    sections: [
      {
        title: "Events & Experiential Marketing",
        text: "We design and deliver immersive brand experiences that go beyond events. From corporate gatherings and product launches to exhibitions, brand activations, and large scale experiential campaigns, we create meaningful moments that inspire engagement, strengthen brand perception, and leave a lasting impact.",
        items: [
          [
            "01 | Immersive Experiences",
            "We transform ideas into engaging, interactive experiences that captivate audiences, encourage participation, and bring brands to life.",
          ],
          [
            "02 | Meaningful Engagement",
            "Every touchpoint is thoughtfully designed to foster authentic interactions, deepen audience connections, and create memorable brand experiences.",
          ],
          [
            "03 | Experiences That Last",
            "We create moments that resonate beyond the event itself, turning one time interactions into lasting impressions and stronger brand recall.",
          ],
          [
            "04 | Impact with Purpose",
            "Whether it's an intimate corporate event or a large scale experiential campaign, every execution is strategically planned to achieve measurable business objectives and deliver meaningful results.",
          ],
        ],
      },
    ],
  },
  {
    slug: "media-technology",
    title: "Media Technology",
    image: mediatechnologyicon,
    icon: mediatechnologyicon,
    hotspot: { top: "65%", left: "45%" },
    hero: "YOUR MARKETING HAS ENOUGH DRAMA. YOUR WORKFLOW SHOULDN'T.",
    intro:
      "Missed approvals.\n\nLost assets.\n\nFive different versions.\n\nThe wrong PDF.\n\nWe've seen enough.\n\nThat's why we build smarter systems that keep teams, content and campaigns moving together without the daily panic attack.\n\nBecause technology should reduce stress.\n\nNot generate support tickets.",
    sections: [
      {
        title: "Media Tech Services",
        text: "We bridge creativity with technology by connecting content, marketing, and digital platforms into one seamless ecosystem. Our solutions simplify workflows, enhance collaboration, and empower brands to create, manage, and scale with greater efficiency.",
        items: [
          [
            "01 | Media Tech",
            "We integrate content, marketing, and technology into connected ecosystems that streamline operations, improve collaboration, and prepare businesses for sustainable digital growth.",
          ],
          [
            "02 | Content Platforms",
            "We build intelligent content ecosystems that enable teams to create, manage, collaborate, and distribute content efficiently across multiple channels and platforms.",
          ],
          [
            "03 | Marketing Platforms",
            "We integrate and optimize marketing technologies that enhance campaign execution, improve audience engagement, and deliver actionable insights through data driven performance.",
          ],
          [
            "04 | Systems & Technology",
            "We design scalable digital workflows that automate processes, connect business systems, and improve operational efficiency making execution faster, smarter, and future ready.",
          ],
        ],
      },
    ],
  },
  {
    slug: "online-reputation-management",
    title: "Online Reputation Management",
    image: ormicon,
    icon: ormicon,
    hotspot: { top: "50%", left: "50%" },
    hero: "THE INTERNET NEVER FORGETS. SO WE TEACH IT BETTER STORIES.",
    intro:
      "People don't meet your brand first.\n\nThey Google it.\n\nEvery review, article, search result and mention quietly decides whether someone trusts you before you've had the chance to introduce yourself.\n\nWe monitor conversations, strengthen credibility and shape your digital presence so your reputation works for you even when you're not in the room.\n\nBecause perception isn't everything.\n\nIt's usually the first thing.",
    sections: [
      {
        title: "SEO, PR & Online Reputation Management",
        text: "Build visibility. Strengthen credibility. Protect your brand.\n\nWe help brands establish a powerful digital presence by combining search optimization, strategic public relations, and reputation management. From increasing discoverability to shaping public perception, we ensure your brand is seen, trusted, and remembered.",
        items: [
          [
            "01 | Monitor",
            "We continuously track search visibility, brand mentions, media coverage, reviews, and online conversations to gain real time insights into how your brand is perceived.",
          ],
          [
            "02 | Optimize",
            "Through strategic SEO, technical optimization, and content led search strategies, we improve your rankings, increase organic visibility, and connect your brand with the right audience.",
          ],
          [
            "03 | Amplify",
            "We elevate your brand's voice through impactful PR campaigns, media relations, thought leadership, and high value content that builds authority and expands your reach.",
          ],
          [
            "04 | Protect",
            "We proactively manage your online reputation by monitoring sentiment, responding to challenges, and implementing reputation strategies that preserve trust and strengthen brand credibility across digital platforms.",
          ],
        ],
      },
    ],
  },
  {
    slug: "atl-btl-marketing",
    title: "ATL & BTL Marketing",
    image: ATLvsBTL,
    icon: ATLvsBTL,
    hotspot: { top: "70%", left: "30%" },
    hero: "WE SHOW UP WHERE YOUR AUDIENCE DOES.",
    intro:
      "Some brands wait to be discovered.\n\nWe'd rather put yours in front of the right people on the streets, in stores, at events, and everywhere in between. From ATL campaigns to on ground activations, we make sure your brand doesn't miss its moment.",
    sections: [
      {
        title: "ATL & BTL Marketing Services",
        items: [
          [
            "ATL Marketing",
            "Amplify your brand through large-scale campaigns across television, print, radio, cinema, outdoor, and premium media channels, creating memorable brand experiences that build awareness, trust, and long-term brand equity.",
          ],
          [
            "BTL Marketing",
            "Bring your brand closer to consumers with immersive activations, experiential events, retail experiences, product launches, roadshows, and engagement led campaigns that transform audiences into loyal customers.",
          ],
          [
            "Connected TV (CTV) & OTT Advertising",
            "Reach premium audiences on Smart TVs and streaming platforms with highly targeted, data driven video campaigns that blend storytelling with precision targeting.",
          ],
          [
            "Experiential & Offline Marketing",
            "Digital meets physical through impactful on ground activations, ambient advertising, and offline campaigns that create memorable brand experiences.",
          ],
          [
            "Outdoor & Billboard Advertising",
            "Capture attention where it matters most with strategically placed outdoor campaigns, combining premium locations, compelling creatives, and intelligent media planning.",
          ],
          [
            "Transit & Vehicle Branding",
            "Turn everyday journeys into high impact brand experiences through creative vehicle wraps, fleet branding, and transit media solutions that maximize visibility.",
          ],
          [
            "Strategic Location Advertising",
            "Own high footfall spaces across residential communities, airports, metro stations, malls, corporate parks, bus shelters, and transit hubs to ensure your brand is seen where your audience is most active.",
          ],
        ],
      },
    ],
  }
];

export const getMediaServiceBySlug = (slug) =>
  mediaServices.find((service) => service.slug === slug);